

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp, FaTrash } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import defaultPic from "../../assets/siteimages/favicon.png"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstroSlots.propTypes = {};

function DashboardAstroSlots(props) {
  // --- existing UI state ---
  const [toggle, setToggle] = useState({ key: "", status: false });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({ status: false });
    } else {
      setToggle({ status: true, key });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({ live: false });
    window.wow.init();
  }, []);

  // --- your existing fetch categories (kept as-is) ---
  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
    fetchSlots(); // fetch slots on mount
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"
      );
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"
      );
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

  const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"
      );
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  // --- auth/context ---
  const { logout } = useContext(AuthContext);

  // --- astrologerId from localStorage (kept from your code) ---
  const [astrologerId, setAstrologerId] = useState(null);
  useEffect(() => {
    const storedUserId = localStorage.getItem("astrologerId");
    if (storedUserId) {
      setAstrologerId(storedUserId);
    }
  }, []);

  // --- slot-specific state ---
  const [checkIn, setCheckIn] = useState(""); // HH:MM (24h)
  const [checkOut, setCheckOut] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [slots, setSlots] = useState([]); // existing slots fetched from server

  // --- helper: parse "HH:MM" to minutes since midnight ---
  const parseToMinutes = (hhmm) => {
    if (!hhmm) return null;
    const [hh, mm] = hhmm.split(":").map((v) => parseInt(v, 10));
    if (Number.isNaN(hh) || Number.isNaN(mm)) return null;
    return hh * 60 + mm;
  };

  // minutes -> "HH:MM"
  const minutesToHHMM = (m) => {
    if (m == null) return "";
    const hh = Math.floor(m / 60);
    const mm = m % 60;
    const hhStr = String(hh).padStart(2, "0");
    const mmStr = String(mm).padStart(2, "0");
    return `${hhStr}:${mmStr}`;
  };

  // --- fetch slots from backend for this astrologer ---
  // NOTE: adapt the endpoint to your backend. I used a plausible route.
  const fetchSlots = async () => {
    if (!astrologerId) return;
    try {
      const resp = await axios.get(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrologer/${astrologerId}/slots`
      );
      // Expecting array of slots: [{ id, start_time: "HH:MM", end_time: "HH:MM", duration }]
      setSlots(Array.isArray(resp.data) ? resp.data : []);
    } catch (err) {
      console.error("fetchSlots error", err);
      // If your backend returns a different shape adapt accordingly
    }
  };

  useEffect(() => {
  if (astrologerId) {
    fetchSlots();
  }
}, [astrologerId]);

  // --- overlap check ---
  // newStartMin, newEndMin are integers minutes since midnight
  const isOverlapping = (newStartMin, newEndMin) => {
    for (const s of slots) {
      // Accept server might store times as strings
      const sStart = parseToMinutes(s.start_time);
      const sEnd = parseToMinutes(s.end_time);
      if (sStart == null || sEnd == null) continue;
      // overlap if newStart < sEnd && newEnd > sStart
      if (newStartMin < sEnd && newEndMin > sStart) return true;
    }
    return false;
  };

  // --- create slot handler ---
  const handleCreateSlot = async () => {
    if (!astrologerId) {
      toast.error("Astrologer not identified. Please login again.");
      return;
    }
    if (!checkIn || !checkOut) {
      toast.error("Please enter both Check-In and Check-Out times.");
      return;
    }

    const startMin = parseToMinutes(checkIn);
    const endMin = parseToMinutes(checkOut);

    if (startMin == null || endMin == null) {
      toast.error("Invalid time format.");
      return;
    }
    if (endMin <= startMin) {
      toast.error("Check-Out must be later than Check-In.");
      return;
    }

    // required duration: first slot 200 min, others 100 min
    const requiredDuration = slots.length === 0 ? 120 : 100;
    const actualDuration = endMin - startMin;

    if (actualDuration !== requiredDuration) {
      toast.error(
        `Invalid slot duration — first slot must be ${requiredDuration} minutes, subsequent slots ${requiredDuration} minutes. You provided ${actualDuration} minutes.`
      );
      return;
    }

    // Overlap validation
    if (isOverlapping(startMin, endMin)) {
      toast.error("This time range overlaps an existing slot. Adjust time.");
      return;
    }

    // Passed client-side validation. Send to server.
    setIsSending(true);
    try {
      // adapt this endpoint/payload to your backend
      const payload = {
        astrologerId,
        start_time: checkIn,
        end_time: checkOut,
        duration: actualDuration,
      };
      // Example POST - change URL as needed
      const resp = await axios.post(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrologer/${astrologerId}/slots`,
        payload
      );


      // On success, refresh slots
      toast.success("Slot created successfully.");
      setCheckIn("");
      setCheckOut("");
      await fetchSlots();
    } catch (err) {
      console.error("create slot error", err);
      // show server message if available
      const msg =
        err?.response?.data?.message ||
        "Failed to create slot. Check server logs or network.";
      toast.error(msg);
    } finally {
      setIsSending(false);
    }
  };

  // --- delete slot ---
  const handleDeleteSlot = async (slotId) => {
    if (!window.confirm("Delete this slot? This action cannot be undone.")) return;
    try {
      // adapt endpoint
      await axios.delete(
        `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/slots/${slotId}`
      );
      toast.success("Slot deleted.");
      // refresh
      await fetchSlots();
    } catch (err) {
      console.error("delete error", err);
      toast.error("Unable to delete slot.");
    }
  };

  return (
    <>
      <Helmet>
        <title>Add eConsultation Slots - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>

       
      <Breadcrumbastrologer title="eConsultation Slots" />

      <section className="account-section" style={{ backgroundColor: "#fafafa" }}>
        <div className="tf-container">
          <div className="row">
            <div className="wd-form-login">
              <img
                src={require("../../assets/siteimages/emailicon.png")}
                style={{
                  width: "120px",
                  height: "auto",
                  margin: "auto",
                  paddingTop: "25px",
                  paddingBottom: "15px",
                }}
                alt="images"
              />
              <h5 style={{ fontSize: "27px" }}>Manage eConsultation Slots</h5>
              <p style={{ marginBottom: "20px" }}>
                Use the following service to add / manage your eConsultation slots.
              </p>

              <div className="ip" style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center", marginBottom: "10px" }}>
                <div style={{ textAlign: "left" }}>
                  <label style={{ display: "block", fontSize: "14px", marginBottom: "6px", fontWeight:"bold" }}>Check-In Time</label>
                  <input
                    type="time"
                    value={checkIn}
                    onChange={(e) => setCheckIn(e.target.value)}
                    placeholder="Enter Check-In Time"
                    style={{ padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                  />
                </div>
                <div style={{ textAlign: "left" }}>
                  <label style={{ display: "block", fontSize: "14px", marginBottom: "6px", fontWeight:"bold" }}>Check-Out Time</label>
                  <input
                    type="time"
                    value={checkOut}
                    onChange={(e) => setCheckOut(e.target.value)}
                    placeholder="Enter Check-Out Time"
                    style={{ padding: "10px", borderRadius: "4px", border: "1px solid #ddd" }}
                  />
                </div>
              </div>

              <div style={{ textAlign: "center", marginBottom: "6px" }}>
                <small style={{ color: "#666" }}>
                  <b>Please Note</b>: First created slot must be 120 minutes. Subsequent slots must be 100 minutes. Overlapping slots are not allowed.
                </small>
              </div>

              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <button
                  onClick={handleCreateSlot}
                  disabled={isSending}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "6px",
                    backgroundColor: "#14a077",
                    color: "white",
                    border: "none",
                    cursor: isSending ? "default" : "pointer",
                  }}
                >
                  {isSending ? "Please Wait..." : "Create Slot"}
                </button>
              </div>

              <style>
                {`
                  .Toastify__close-button {
                    display: none;
                  }
                  .Toastify__toast {
                    position: relative;
                    padding-right: 30px;
                  }
                  .slots-table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-top: 20px;
                  }
                  .slots-table th, .slots-table td {
                    border: 1px solid #e8e8e8;
                    padding: 8px 10px;
                    text-align: center;
                    font-size: 14px;
                  }
                  .slots-table th {
                    background: #f5f5f5;
                  }
                `}
              </style>

              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
<hr/>
              {/* Slots datatable */}
              <div style={{ marginTop: "10px" }}>
                <h6 style={{ textAlign: "center", marginBottom: "0px", fontSize:"16px" }}>Review Existing Slots</h6>

                <div style={{ overflowX: "auto" }}>
                  <table className="slots-table">
                    <thead>
                      <tr style={{fontWeight:"bold"}}>
                        <th>#</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Duration (mins)</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {slots && slots.length > 0 ? (
                        slots.map((s, idx) => {
                          // adapt in case your slot object fields differ
                          const start = s.start_time || minutesToHHMM(parseToMinutes(s.start_time));
                          const end = s.end_time || minutesToHHMM(parseToMinutes(s.end_time));
                          const dur =
                            s.duration != null
                              ? s.duration
                              : (() => {
                                  const a = parseToMinutes(s.start_time);
                                  const b = parseToMinutes(s.end_time);
                                  return a != null && b != null ? b - a : "";
                                })();

                          return (
                            <tr key={s.id || `${idx}-${start}`}>
                              <td>{idx + 1}</td>
                              <td>{start}</td>
                              <td>{end}</td>
                              <td>{dur}</td>
                              <td>
                                <button
                                  title="Delete slot"
                                  onClick={() => handleDeleteSlot(s.id)}
                                  style={{
                                    padding: "6px 10px",
                                    borderRadius: "6px",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    backgroundColor: "#dc3545",
                                    color: "white",
                                    fontSize: "13px",
                                  }}
                                >
                                  <FaTrash /> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ padding: "20px" }}>
                            No slots created yet.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="group-ant-choice" style={{ marginTop: "15px", textAlign: "center" }}>
                <Link to="/astrologer Dashboard" className="forgot" style={{ margin: "auto" }}>
                  Return To Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="floating-buttons"
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          zIndex: "1000",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {/* Call Button */}
        <a
          href={`tel:+918960708425`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#007BFF",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaPhoneAlt />
        </a>

        {/* WhatsApp Button */}
        <a
          href={`https://wa.me/918960708425`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaWhatsapp />
        </a>
      </div>

   
      <Gotop />
    </>
  );
}

export default DashboardAstroSlots;